import * as React from 'react';

import {colors} from '../colors/colors';
import {MultiLine} from '../multi-line/multi-line';
import {TwoLine} from '../two-line/two-line';
import {Body} from '../typography/body';

type PrimaryCellData = {
    icon?: React.ComponentType<any>;
    text: string;
    subtitle?: string | null | undefined;
    tertiary?: string | null | undefined;
    subtitleDefault?: string;
    tertiaryDefault?: string;
    subtitleIsPill?: boolean;
};

type Props = {
    cell: {
        value: PrimaryCellData;
    };
};

export const TablePrimaryCell = ({cell}: Props) => {
    const {icon, text, subtitle, tertiary, subtitleDefault, tertiaryDefault, subtitleIsPill} =
        cell.value;

    if (tertiary !== undefined || tertiaryDefault) {
        return (
            <MultiLine
                title={text}
                subtitles={[
                    subtitle
                        ? {text: subtitle, isPill: subtitleIsPill}
                        : {text: subtitleDefault || '', isPill: subtitleIsPill},
                    tertiary ? {text: tertiary} : {text: tertiaryDefault || '', isItalic: true},
                ]}
                truncate={{type: 'block'}}
            />
        );
    }

    return (
        <TwoLine
            icon={icon}
            iconSize={12}
            iconColor={colors.black}
            topRow={
                <Body size='small' truncate={{type: 'block'}}>
                    {text}
                </Body>
            }
            bottomRow={
                subtitle !== undefined && (
                    <Body size='mini' truncate={{type: 'block'}} isItalic={!subtitle}>
                        {subtitle || subtitleDefault}
                    </Body>
                )
            }
            shouldCenterSingleLine={true}
        />
    );
};
